import IJobSection from "../../interfaces/IJobSection";
import CatalyticResiduesBoxContent from "../CatalyticResiduesBoxContent";
import Icons from "../Icons";
import * as React from "react";
import { useState } from "react";
import { BoxHeader } from "./box-header";
import { BoxHeaderOption } from "./box-header-option";
import { useResultsContext } from "../../context/results-context";
import { Section } from "./section";

export function SectionCatalyticResidues({section}: {section: IJobSection}) {
  const {results} = useResultsContext();

  const [differences, setDifferences] = useState(false);
  const [details, setDetails] = useState(false);

  return (
    <Section section={section} className="ll-break-inside-avoid" style={{marginTop: '1rem',}}>
      <BoxHeader section={section}>
        <BoxHeaderOption title="differences" checked={differences} setChecked={setDifferences}/>
        <BoxHeaderOption title="details" checked={details} setChecked={setDetails}/>
      </BoxHeader>
      <CatalyticResiduesBoxContent
        title={`${results.mutationStr} Changes (pKa):`}
        mutant={results.mutationStr}
        items={results.catalyticResidues}
        icons={Icons}
        iconFirst={true}
        differences={differences}
        details={details}
      />
    </Section>
  )
}